import { render, staticRenderFns } from "./universal-modal.vue?vue&type=template&id=66ad1f71&scoped=true&"
import script from "./universal-modal.vue?vue&type=script&lang=js&"
export * from "./universal-modal.vue?vue&type=script&lang=js&"
import style0 from "./universal-modal.vue?vue&type=style&index=0&id=66ad1f71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ad1f71",
  null
  
)

export default component.exports